// Регистрация панелей раздела «Суточные расходы» в каркасе. Побочный эффект при загрузке модуля: раздел
// объявляет, что умеет рисовать в стопке панелей, а каркас остаётся без знания о разделах.
// Импортируется из MoneySection — то есть ровно тогда, когда раздел попадает в сборку экрана.

import { registerPanel } from '@/layout/panel-registry';

import {
  PANEL_CLAIM,
  PANEL_ISSUE,
  PANEL_NEW_CLAIM,
  PANEL_PERSON_SETTINGS,
  PANEL_SUMMARY,
  PANEL_RETURN,
  PANEL_TRANSFER,
} from '../route';

import { СводкаПодотчёта } from '../components/СводкаПодотчёта';

import { ClaimPanel } from './ClaimPanel';
import { SettingsPanel } from './SettingsPanel';
import { IssuePanel } from './IssuePanel';
import { NewClaimPanel } from './NewClaimPanel';
import { ReturnPanel } from './ReturnPanel';
import { TransferPanel } from './TransferPanel';

registerPanel(PANEL_ISSUE, {
  title: () => 'Оформить выдачу',
  render: ({ id, onClose }) => <IssuePanel id={id} onClose={onClose} />,
});

registerPanel(PANEL_RETURN, {
  title: () => 'Оформить возврат',
  render: ({ id, onClose }) => <ReturnPanel id={id} onClose={onClose} />,
});

registerPanel(PANEL_TRANSFER, {
  title: () => 'Передать остаток',
  render: ({ id, onClose }) => <TransferPanel id={id} onClose={onClose} />,
});

registerPanel(PANEL_CLAIM, {
  title: () => 'Заявка подотчёта',
  render: ({ id, onClose }) => <ClaimPanel id={id} onClose={onClose} />,
});

registerPanel(PANEL_NEW_CLAIM, {
  title: () => 'Отчитаться по чеку',
  render: ({ id, onClose }) => <NewClaimPanel id={id} onClose={onClose} />,
});

registerPanel(PANEL_PERSON_SETTINGS, {
  title: () => 'Настройки подотчёта',
  render: ({ id, onClose }) => <SettingsPanel id={id} onClose={onClose} />,
});

registerPanel(PANEL_SUMMARY, {
  title: () => 'Сводка за период',
  // Опознаватель здесь — юрлицо из отбора либо «все»: сводка считается по той же выборке,
  // что и список под ней. Иначе числа в панели отвечали бы на другой вопрос, чем список,
  // и человек читал бы это как расхождение.
  render: ({ id }) => <СводкаПодотчёта legalEntityId={id === 'все' ? undefined : id} />,
});
